import { START_QUESTION, SHOW_ANSWER, SHOW_WAITING, ANSWER_QUESTION, SHOW_COMMERCIAL, SHOW_VOUCHER_WINNER, SHOW_FINAL_RESULTS, QUESTION_TIMER_FINISHED, QuizStates } from '../actions/quiz';


const initialQuizState = {
  currentQuizStep: QuizStates.WAITING,
  currentQuestion: null,
  
  startTime: null,
  currentResult: null,
  commercialResult: null,
  voucherResult: null,
  gameCompleted: false,
  endQuizResults: null,
  questionTimerFinished: false
}

const loginState = (state = initialQuizState, action) => {
  switch (action.type) {
    case START_QUESTION:
      return { ...state, questionTimerFinished: false, currentQuizStep: QuizStates.QUESTION, currentQuestion: action.question, startTime: Date.now() };        
    case ANSWER_QUESTION:
      const updatedCurrentQuestion = state.currentQuestion;
      updatedCurrentQuestion.answered = action.answerId;
      return { ...state, currentQuestion: updatedCurrentQuestion, currentQuizStep: QuizStates.WAITING }
    case SHOW_ANSWER:
      return { ...state, currentQuizStep: QuizStates.ANSWER, currentResult: action.result };
    case SHOW_WAITING:
      return { ...state, currentQuizStep: QuizStates.WAITING };
    case SHOW_COMMERCIAL:
      return { ...state, currentQuizStep: QuizStates.COMMERCIAL, commercialResult: action.result }
    case SHOW_VOUCHER_WINNER:
      return { ...state, currentQuizStep: QuizStates.VOUCHER_WINNER, gameCompleted: true, voucherResult: action.result }
    case SHOW_FINAL_RESULTS:
      return { ...state, gameCompleted: true, endQuizResults: action.result };
    case QUESTION_TIMER_FINISHED:
      return { ...state, questionTimerFinished: true };
    default:
      return state
  }
}
  
export default loginState;


// WEBPACK FOOTER //
// ./src/components/store/reducers/quiz.js